<div
  class="dropzone"
  appFileDropzone
  #dz="appFileDropzone"
  [accept]="accept()"
  [maxSize]="maxSize()"
  [multiple]="multiple()"
  [disabled]="disabled()"
  [class.is-dragging]="dz.dragging()"
  [class.is-disabled]="disabled()"
  (click)="dz.browse()"
  (filesSelected)="filesSelected.emit($event)"
  (filesRejected)="filesRejected.emit($event)"
>
  <div class="dropzone-info">
    <span class="dropzone-chip">
      <aiwyn-icon name="upload" class="dropzone-icon" [height]="16" [width]="16"></aiwyn-icon>
    </span>

    <div class="dropzone-text">
      <p class="dropzone-title">Drag and drop files or folders here to upload</p>
      <p class="dropzone-hint">You can upload PDF, DOC, and image file formats.</p>
    </div>
  </div>

  <button
    andButton
    color="primary"
    size="small"
    class="dropzone-browse"
    [disabled]="disabled()"
    [dataSelector]="'cxp-crl-bulk-dropzone-browse'"
  >Browse Files</button>
</div>

<button
  andButton
  color="primary"
  size="regular"
  class="dropzone-mobile-upload"
  [disabled]="disabled()"
  [dataSelector]="'cxp-crl-bulk-dropzone-mobile-upload'"
  (click)="dz.browse()"
>
  <aiwyn-icon name="upload" class="dropzone-mobile-icon" [height]="16" [width]="16"></aiwyn-icon>
  Upload Files
</button>
